import { Page } from "@tfg/ui"
import { useState } from "react"
import { useTranslation } from "react-i18next"
import { Outlet } from "react-router-dom"

import { OrganizationsResponses } from "@tfg/types/endpoints/organizations"

import { ProductSheetGroupSelect } from "~/pages/Brand/CommunicationStudio/ProductSheetGroupSelect"
import { useOrganizationSettings } from "~/pages/Brand/CommunicationStudio/contexts/organizationSettings/useOrganizationSettings"
import { ProductSheetGroupContext } from "~/pages/Brand/CommunicationStudio/contexts/productSheetGroup/ProductSheetGroupContext"

export const CommunicationStudio = () => {
  const { t } = useTranslation("communicationStudio")
  const organizationSettings = useOrganizationSettings()
  const productSheetGroups = organizationSettings.displaySettings
  const defaultProductSheetGroup =
    productSheetGroups && productSheetGroups.length > 0
      ? productSheetGroups[0]
      : null

  const [selectedProductSheetGroup, setSelectedProductSheetGroup] = useState<
    | OrganizationsResponses.OrganizationSettings["displaySettings"][number]
    | null
  >(defaultProductSheetGroup)

  const pages = [
    {
      label: t("tabs.general.label"),
      link: "general",
      tooltip: t("tabs.general.tooltip"),
    },
    {
      label: t("tabs.languages.label"),
      link: "languages",
      tooltip: t("tabs.languages.tooltip"),
    },
    {
      label: t("tabs.design.label"),
      link: "design",
      tooltip: t("tabs.design.tooltip"),
    },
    {
      label: t("tabs.content.label"),
      link: "content",
      tooltip: t("tabs.content.tooltip"),
    },
  ]

  return (
    <ProductSheetGroupContext.Provider
      value={{
        selectedProductSheetGroup,
        setSelectedProductSheetGroup: (productSheetGroup) => {
          setSelectedProductSheetGroup(productSheetGroup ?? null)
        },
      }}
    >
      <Page
        title={t("title")}
        pages={pages}
        mainCta={
          productSheetGroups.length > 1 && (
            <ProductSheetGroupSelect productSheetGroups={productSheetGroups} />
          )
        }
      >
        <Outlet />
      </Page>
    </ProductSheetGroupContext.Provider>
  )
}
